import { Album, SyncSettings } from '../types';

/**
 * Pure fetcher for cloud sync.
 * Does not perform merging; returns raw remote data for the app to merge against live state.
 */
export async function syncWithCloud(
  localAlbums: Album[],
  settings: SyncSettings,
  deviceId: string
): Promise<{ remoteAlbums: Album[]; serverTime: number }> {
  if (!settings.scriptUrl) {
    throw new Error('Sync URL not configured');
  }

  const payload = {
    action: 'sync',
    deviceLabel: settings.deviceLabel || 'This Device',
    payload: { albums: localAlbums }
  };

  if (process.env.NODE_ENV === 'development') {
    console.log('[Sync] Outbound payload:', { albumCount: localAlbums.length });
  }

  const response = await fetch(settings.scriptUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'text/plain;charset=utf-8',
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    throw new Error(`Cloud sync failed: ${response.status} ${response.statusText}`);
  }

  const result = await response.json();

  if (!result.ok) {
    throw new Error(result.message || 'Server rejected sync request');
  }

  return {
    remoteAlbums: result.data?.albums || [],
    serverTime: result.serverTime || Date.now()
  };
}